module.exports = __webpack_public_path__ + "9a1dce4c516c87792306e7625ddb3d64.svg";